import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { portalPost, clearPortalToken } from '../../lib/portalApi';

export default function PortalChangePasswordModal({ onDone }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (next.length < 8) return toast.error('New password must be at least 8 characters');
    if (next !== confirm) return toast.error('Passwords do not match');
    setSaving(true);
    try {
      await portalPost('/portal/change-password', { current_password: current, new_password: next });
      toast.success('Password updated');
      onDone();
    } catch (e) {
      const detail = e?.response?.data?.detail;
      toast.error(detail || 'Failed to update password');
      if (e?.response?.status === 401) { clearPortalToken(); window.location.href = '/portal/login'; }
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[1000] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-sm w-full max-w-sm p-5">
        <div className="font-display font-bold text-base mb-1">Set a new password</div>
        <p className="text-xs text-slate-500 mb-4">This is your first login — choose a password only you know.</p>
        <div className="space-y-3">
          <div>
            <label className="label">Temporary Password</label>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="input" autoFocus data-testid="portal-change-current" />
          </div>
          <div>
            <label className="label">New Password</label>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="input" data-testid="portal-change-new" />
          </div>
          <div>
            <label className="label">Confirm New Password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input" data-testid="portal-change-confirm" />
          </div>
          <button onClick={save} disabled={saving} className="btn-primary w-full justify-center mt-1" data-testid="portal-change-submit">
            {saving ? <Loader2 size={14} className="animate-spin" /> : 'Set Password'}
          </button>
        </div>
      </div>
    </div>
  );
}
